@if (type === 'overlay') {
  <div class="toolbox-overlay"
       [style.visibility]="componentVisible ? 'visible' : 'hidden'" >
    <div [ngClass]='["background", type]'></div>
    <mat-card [ngClass]='["toolbox", type, displayTitle ? "w-title" : "wo-title"]'>
      <mat-card-header>
        @if (displayTitle) {
          <mat-card-title>
            {{ 'i18n.toolbox.layout.title' | translate }}
          </mat-card-title>
        }
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="btnCancelClick()"></mat-icon>
      </mat-card-header>
      @if (templateGroups) {
        <mat-card-content>
          <template-chooser
            [templateGroups]="templateGroups"
            [templatesSettings]="templatesSettings"
            [(selectedTemplateId)]="templateId"
            (selectedTemplateIdChange)="updateSelectedTemplateId($event)"
            [(selectedTemplateGroupId)]="templateGroupId"
            (selectedTemplateChange)="updateSelectedTemplate($event.templateGroupId, $event.templateId)"
            (selectedTemplateNotChange)="closeIfSmallOrMediumDevice()"
          ></template-chooser>
        </mat-card-content>
      }
    </mat-card>
  </div>
}

@if (type === 'static') {
  <div class="toolbox-static"
       [style.visibility]="componentVisible ? 'visible' : 'hidden'" >
    <div class="header">
      @if (displayTitle) {
        @if (displayTitle) {
          <span class="title">
            <mat-icon svgIcon="layouts"></mat-icon>
            {{ 'i18n.toolbox.layout.title' | translate }}
          </span>
        }
        <hr class="title-hr" />
      }
    </div>
    @if (templateGroups) {
      <div class="body">
        <template-chooser
          [templateGroups]="templateGroups"
          [templatesSettings]="templatesSettings"
          [(selectedTemplateId)]="templateId"
          (selectedTemplateIdChange)="updateSelectedTemplateId($event)"
          [(selectedTemplateGroupId)]="templateGroupId"
          (selectedTemplateChange)="updateSelectedTemplate($event.templateGroupId, $event.templateId)"
          (selectedTemplateNotChange)="closeIfSmallOrMediumDevice()"
        ></template-chooser>
      </div>
    }
  </div>
}
